import snakeCase from 'lodash.snakecase';
import { doesCartContainSubscription } from '../../utils';
import { CIOCartItem, CIOCart, CIOCheckout, CIOOrder, CIOSubscription } from './types';

function snakeCaseKeys(obj: any): any {
  const isObject = Object.prototype.toString.call(obj) === '[object Object]';

  if (!isObject) {
    return obj;
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [snakeCase(key), snakeCaseKeys(value)]),
  );
}

export const cioSerializeCartItem = (kit: Kit, cart?: Cart): CIOCartItem => ({
  ...(cart?.id ? { cart_id: cart.id } : {}),
  ...(cart?.currency ? { currency: cart.currency } : {}),
  discount: kit.discounted ? kit.discount : 0,
  discount_rules: kit.discountRules,
  is_prepaid_subscription: kit.isPrepaidSubscription || false,
  kit_id: kit.kitId,
  name: kit.itemName,
  price: kit.price,
  product_id: kit.itemId,
  quantity: 1,
  sku: kit.sku,
  tracking_id: kit.trackingId,
  value: kit.discounted ? kit.discountPrice : kit.price, // CIO: The expected total revenue of the transaction calculated with discounts/coupons.
});

export const cioSerializeCart = (cart: Cart): CIOCart => ({
  cart_id: cart.id,
  coupon: cart.couponCodes?.join(', ') || '',
  currency: cart.currency,
  discount: cart.totals.itemsDiscount,
  has_prepaid_subscription: doesCartContainSubscription(cart),
  products: cart.kits.map((kit) => cioSerializeCartItem(kit)),
  revenue: cart.totals.itemsTotal, // CIO: The total revenue of the transaction without discounts, coupons, shipping, and tax.
  shipping: cart.totals.shippingWithDiscount,
  tax: cart.totals.taxAmount,
});

export const cioSerializeCheckout = (cart: Cart, subscription?: CIOSubscription): CIOCheckout => {
  let data: Partial<CIOCheckout> = {};

  if (!cart.id && !subscription) {
    throw new Error('Cannot serialize checkout without cart ID or subscription info');
  }

  if (cart.id) {
    data = {
      ...cioSerializeCart(cart),
      value: cart.totals.itemsTotalWithDiscount, // CIO: The expected total revenue of the transaction calculated with discounts/coupons.
    };
  }

  if (subscription) {
    data = {
      ...data,
      subscription: snakeCaseKeys(subscription),
    };
  }

  return data as CIOCheckout;
};
